import { render, staticRenderFns } from "./email-input.vue?vue&type=template&id=4c50f2e0"
import script from "./email-input.vue?vue&type=script&lang=js"
export * from "./email-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c50f2e0')) {
      api.createRecord('4c50f2e0', component.options)
    } else {
      api.reload('4c50f2e0', component.options)
    }
    module.hot.accept("./email-input.vue?vue&type=template&id=4c50f2e0", function () {
      api.rerender('4c50f2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/inputs/email-input.vue"
export default component.exports